import { Edit, Form, Input, Select, Table, TextField, useForm } from '@pankod/refine-antd';
import { IResourceComponentsProps, useShow } from '@pankod/refine-core';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { ISample } from 'types/sample.interface';
import { SampleSourceOptions } from './utils';
import type { ColumnsType } from 'antd/es/table';
import { ITrack } from 'types/track.interface';
import { useMemo } from 'react';
import { formatDateTime } from 'utils';
export const SampleEdit: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps, formLoading } = useForm<ISample>();

    const { queryResult } = useShow<ISample>();
    const { data, isLoading } = queryResult;
    const record: any = data?.data;
    console.log(record?.relatedTracks, '000000000');

    const columnsTrack: ColumnsType<ITrack> = useMemo(
        () => [
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                render: (value: any) => <TextField value={value} />,
            },
            {
                title: 'Artist',
                dataIndex: 'artist',
                key: 'artist',
                render: (value: any) => <TextField value={value} />,
            },
            {
                title: 'Label',
                dataIndex: 'label',
                key: 'label',
                render: (value: any) => <TextField value={value.name} />,
            },
            {
                title: 'createdAt',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: (value: any) => <TextField value={formatDateTime(value)} />,
            },
        ],
        []
    );

    return (
        <Edit saveButtonProps={saveButtonProps} isLoading={isLoading || formLoading}>
            <Form {...formProps} layout='vertical'>
                <Form.Item
                    label='Track'
                    name='track'
                    rules={[
                        {
                            required: true,
                            message: 'Track is required',
                        },
                    ]}
                    initialValue={record?.data.track}
                >
                    <Input defaultValue={record?.data.track} />
                </Form.Item>
                <Form.Item
                    label='Title'
                    name='title'
                    rules={[
                        {
                            required: true,
                            message: 'Title is required',
                        },
                    ]}
                    initialValue={record?.data.title}
                >
                    <Input defaultValue={record?.data.title} />
                </Form.Item>
                <Form.Item
                    label='Artist'
                    name='artist'
                    rules={[
                        {
                            required: true,
                            message: 'Artist is required',
                        },
                    ]}
                    initialValue={record?.data.artist}
                >
                    <Input defaultValue={record?.data.artist} />
                </Form.Item>
                <Form.Item
                    label='Source'
                    name='source'
                    rules={[
                        {
                            required: true,
                            message: 'Source is required',
                        },
                    ]}
                    initialValue={record?.data.source}
                >
                    <Select options={SampleSourceOptions} defaultValue={record?.data.source} />
                </Form.Item>
                <Form.Item
                    label='Original Track Url'
                    name='originalTrackUrl'
                    rules={[
                        {
                            required: false,
                            message: 'Original Track Url is required',
                        },
                    ]}
                    initialValue={record?.data.originalTrackUrl}
                >
                    <Input defaultValue={record?.data.originalTrackUrl} />
                </Form.Item>
            </Form>
            <TextField value='Related track' style={{ fontSize: '16px', fontWeight: 700, marginBottom: '20px' }} />
            <Table dataSource={record?.data?.relatedTracks} columns={columnsTrack} pagination={false} />
        </Edit>
    );
};
